import type { ActivityLogRow } from '../models.ts';

/**
 * Activity-log rows where the exchange had no usable book often carry midPrice = 0
 * and empty bid/ask arrays, which makes line charts spike down to the axis.
 */
export function isEmptyOrderBookSnapshot(row: ActivityLogRow): boolean {
  if (row.bidPrices.length === 0 && row.askPrices.length === 0) {
    return true;
  }
  if (!Number.isFinite(row.midPrice) || row.midPrice === 0) {
    return true;
  }
  return false;
}
